import React, { useEffect, useState } from "react";
import { meApi, formatApiError, getToken } from "@/lib/api";
import { PageHeader, Card, SaveBar } from "./_shared";
import { Plus, Trash2, Download } from "lucide-react";
import { toast } from "sonner";

export default function Planning() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(""); const [err, setErr] = useState("");

  useEffect(() => {
    meApi.getPlanning().then((d) => setItems(d.items || [])).catch(() => {});
  }, []);

  const add = () => setItems((it) => [...it, { heure: "", label: "", notes: "" }]);
  const rm = (i) => setItems((it) => it.filter((_, idx) => idx !== i));
  const update = (i, k, v) => setItems((it) => it.map((row, idx) => idx === i ? { ...row, [k]: v } : row));

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setErr(""); setSaving(true);
    try {
      const r = await meApi.savePlanning({ items });
      setItems(r.items || []);
      setMsg("Planning enregistré.");
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="ec-planning">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <PageHeader eyebrow="Déroulé" title="Mon" italic="planning." desc="Le déroulé heure par heure de votre soirée. Modifiable à volonté." />
        <button
          type="button"
          onClick={async () => {
            try {
              const token = getToken();
              const r = await fetch(meApi.planningPdfUrl(), { headers: { Authorization: `Bearer ${token}` } });
              if (!r.ok) throw new Error("Impossible de générer le PDF.");
              const blob = await r.blob();
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url; a.download = "planning-my-animation.pdf"; a.click();
              URL.revokeObjectURL(url);
              toast.success("Planning téléchargé.");
            } catch (e) { toast.error(formatApiError(e)); }
          }}
          data-testid="planning-pdf-download"
          className="btn-ghost-gold inline-flex items-center gap-2 !py-2.5 !text-[11px] mt-2"
        >
          <Download size={13} strokeWidth={1.5} /> Télécharger en PDF
        </button>
      </div>
      <Card>
        <form onSubmit={submit}>
          <div className="space-y-3">
            {items.length === 0 && (
              <p className="text-sm text-white/50 italic">Aucune étape pour l&apos;instant. Ajoutez-en une avec le bouton ci-dessous.</p>
            )}
            {items.map((row, i) => (
              <div key={i} className="grid grid-cols-12 gap-3 items-start bg-black/30 border border-[#DCB457]/15 p-3" data-testid={`planning-row-${i}`}>
                <input
                  type="time"
                  value={row.heure}
                  onChange={(e) => update(i, "heure", e.target.value)}
                  data-testid={`planning-heure-${i}`}
                  className="col-span-3 md:col-span-2 bg-black/60 border border-[#DCB457]/25 px-3 py-2 text-sm text-white focus:border-[#DCB457] focus:outline-none"
                />
                <input
                  type="text"
                  value={row.label}
                  onChange={(e) => update(i, "label", e.target.value)}
                  placeholder="ex. Cocktail / Entrée des mariés"
                  data-testid={`planning-label-${i}`}
                  className="col-span-9 md:col-span-5 bg-black/60 border border-[#DCB457]/25 px-3 py-2 text-sm text-white focus:border-[#DCB457] focus:outline-none"
                />
                <input
                  type="text"
                  value={row.notes}
                  onChange={(e) => update(i, "notes", e.target.value)}
                  placeholder="Notes"
                  data-testid={`planning-notes-${i}`}
                  className="col-span-10 md:col-span-4 bg-black/60 border border-[#DCB457]/25 px-3 py-2 text-sm text-white focus:border-[#DCB457] focus:outline-none"
                />
                <button type="button" onClick={() => rm(i)} data-testid={`planning-rm-${i}`} className="col-span-2 md:col-span-1 inline-flex items-center justify-center text-red-300 hover:text-red-400 border border-red-400/30 hover:border-red-400/60 py-2">
                  <Trash2 size={14} strokeWidth={1.4} />
                </button>
              </div>
            ))}
          </div>
          <button type="button" onClick={add} data-testid="planning-add" className="mt-5 inline-flex items-center gap-2 text-sm text-[#DCB457] border border-[#DCB457]/40 px-4 py-2 hover:bg-[#DCB457]/10 transition">
            <Plus size={14} strokeWidth={1.4} /> Ajouter une étape
          </button>
          {err && <p className="text-xs text-red-300 mt-3">{err}</p>}
          <SaveBar saving={saving} message={msg} />
        </form>
      </Card>
    </div>
  );
}
